// Imports
import { PortalContext } from 'src/modules/01 Global/jsx/contexts.jsx';


// Stateless components

export function Link(props) {

    var link_data = props['data'];

    //
    // Render
    //

    function renderLink(context) {
        var icons = context['configuration']['icons'];
        var internal_icon = {
            '__html': icons['chevron_right']
        };
        var external_icon = {
            '__html': icons['external_link']
        };

        var link_url = link_data['url'];
        var link_class = link_data['class'];
        var link_label = link_data['label'];
        var link_type = squiz.fn.getLinkType(link_url);

        // Handle links to unavailable content
        if(link_type === 'null') {
            return null;
        }

        if(link_type === 'external') {
            return (
                <a href={link_url} className={link_class} target="_blank">{link_label} <span dangerouslySetInnerHTML={external_icon}></span></a>
            )
        }

        return (
            <a href={link_url} className={link_class} target="_self">{link_label} <span dangerouslySetInnerHTML={internal_icon}></span></a>
        )
    }

    return (
        <PortalContext.Consumer>
            {renderLink}
        </PortalContext.Consumer>
    );

};
